module.exports = __webpack_public_path__ + "img/arrow-right-tail-b.516a9431.svg";